<template>
  <div>
    <CCard>
      <header class="card-header grey-header d-flex">
        <div class="row flex-flow-column">
          <div class="col">
            <strong>{{ $t("setupPricing.title") }}</strong>
          </div>
          <p
            class="desc"
          >{{ $t("setupPricing.desc") }}</p>
        </div>
         <CButton class="align-right btn-lit-blue" @click="navigateToManagePricing(null)" color="success">{{ $t("setupPricing.new") }}</CButton>
      </header>
      <!-- <CCardHeader>
        <CRow>
          <CCol>
            <strong>{{ $t("setupPricing.title") }}</strong>
          </CCol>

          <CCol class="text-right p-10px">
            <CButton
              @click="navigateToManagePricing(null)"
              color="success"
            >{{ $t("setupPricing.new") }}</CButton>
          </CCol>
        </CRow>
      </CCardHeader> -->

      <CCardBody>
     <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
                       <div class="table-count-wrap">
          <div class="d-inline-flex">
            <div class="single-tab" v-if="tiersCount&&tiersCount.total">
              <div class="tc-total-wrap">
              <span>
                {{ $t("setupPricing.totalTier") }}
              </span> <span>{{ tiersCount.total}}</span>
              </div>

            </div>

            <div class="single-tab" v-if="tiersCount&&tiersCount.active">
            <div class="tc-active-wrap">
              <span>{{ $t("setupPricing.active") }}</span> <span>{{tiersCount.active}}</span>
            </div>

            </div>
            <div class="single-tab" v-if="tiersCount&&(tiersCount.inActive||tiersCount.inActive==0)">
              <div class="tc-inactive-wrap">
                <span>{{ $t("setupPricing.inactive") }} </span> <span>{{tiersCount.inActive}}</span>
              </div>

            </div>

           
          </div>
        </div>


        <cTable class="table table-striped table-hover price-table"
                   
          :items="lsSetupPricingTableItems"
          :fields="lsFields"
          column-filter
          items-per-page-select
          :items-per-page="setupPricingTableWatchList.itemsPerPage"
          hover
         :sorter='{  resetable: true }'
         @row-clicked="navigateToManagePricing"
          pagination
          :loading="isLoading"
        id="user-manage-table"
                      :sorterValue="{ column: 'name', asc: 'true' }"
                       @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
                      :tableWatchList="setupPricingTableWatchList"
             @getFields="onSaveColumns"
             manageColumn
            paginationLenOption
>

    <!-- <template #over-table>
  <cManageColumns v-if="lsFields&&lsFields.length>0" :lsFields="lsFields" @getFields="onSaveColumns"/>
        <cPaginationLenOption :paginationWatchLs="setupPricingTableWatchList"/>

              </template> -->

 <template #isactive-filter>
            <div>
              <cDropDown
               
                url="pricingStatus"
                :isAllowEmpty="false"
                :ctrlCode="'value'"
                :ctrlName="'name'"
                :isShowCode="false"
                :isMultiple="false"
                :isSearchable="true"
                
                v-on:input="onStatusChange"
                class="hide-invalid-feedback"
              />
            </div>
          </template>
        

          <template #no-items-view>
            <div class="text-center my-5">
              <h2>{{isLoading?'':$t("setupPricing.listEmpty") }} </h2>

            </div>
          </template>
          <template #actions="{item}">
            <td>
              <CRow>
                <CCol>
                  <CButton @click.stop="navigateToManagePricing(item)" class="btn btn-success">
                    <span>{{ $t("setupPricing.manage") }}</span>

                  </CButton>
                </CCol>

                <CCol class="clone-price-ico">
                  <div @click.stop="clonePricingTier(item.tierid,item.name)"  v-c-tooltip.hover="{ content: $t('helpTip.setupPricingClone') , active:false }">
                    <CIcon style="" name="cil-clone" size="lg"></CIcon>
                  </div>
                </CCol>
                
                <div  v-c-tooltip.hover="{ content: 'Delete' , active:false }" v-if="lsPricingTiers.permission.Delete"
                  @click.stop="
                    setAlertModalDetails(
                      getDeleteModalButtons(item.tierid),
                     $t('setupPricing.deleteStatus', {
                        name: item.name
                      }),
                      2
                    )
                  "
                >
                  <CIcon style="color: #cd0606;" name="cil-trash" size="lg"></CIcon>
                </div>
                <CCol></CCol>
              </CRow>
            </td>
          </template>

          <template #isactive="{item}">
            <td>
              <CBadge :color="item.isactive ? 'success' : 'danger'">
                {{
                item.isactive ? "Active" : "Inactive"
                }}
              </CBadge>
            </td>
          </template>
<!--          <template #over-table>-->
<!--            <div>-->
              <!-- <CRow>
                
                <CCol class="col-form-label col-sm-6 top-t-pricing-table">
                  <span>
                    <strong>{{ $t("setupPricing.currStatus") }}</strong>
                  </span>
                </CCol>
                <CCol class="col-form-label col-sm-3 ">
                  <cDropDown
                    :url="getPricingStatusURL()"
                    :isAllowEmpty="false"
                    :ctrlCode="'value'"
                    :ctrlName="'name'"
                    :isShowCode="false"
                    :isMultiple="false"
                    :isSearchable="false"
                    v-on:input="onStatusChange"
                  ></cDropDown>
                </CCol>
                <CCol class="col-form-label col-sm-3">
                  
                </CCol>
              </CRow> -->
<!--            </div>-->
<!--          </template>-->
        </cTable>
       

      </CCardBody>
    </CCard>

    <cAlertModal v-if="showAlertModal"
      :show="showAlertModal"
      :status="modalStatus"
      :infoTitle="$t('setupPricing.delete')"
      :buttonList="lsModalButtons"
      :desc="modalDesc"
    ></cAlertModal>
  </div>
</template>

<script>
import cDropDown from "./../../components/form/cDropDown";
import router, { navigate, goBack } from "./../../router/index";
import cAlertModal from "./../../components/form/cAlertModal";
import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME, SECTOR_TYPE ,ORDER} from "./../../util/constants";
import apiAllPricingTiers from "./../../services/apiAllPricingTiers";
import apiClonePricingTier from "./../../services/apiClonePricingTier";
import apiDeletePricingTier from "./../../services/apiDeletePricingTier";
import Logger from "./../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue,addClassToBody,removeClassBody,OrderByList } from "../../util/util";
import BaseConfiguration from "../../config/base.js";
import cTable from "../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.SETUP_PRICING,
  components: {
    cDropDown,
    cAlertModal,
    cTable
  },
  data: () => {
    return {
      setupPricingTableWatchList:{
      filteredlistCount:null,
      itemsPerPage:25,
       currentPageNum:1
       },
      //pricingStatusURL: null,
      lsPricingTiers: null,
     
      lsSetupPricingTableItems: [],
      lsFields: [],
      alertValue: null,
      lsModalButtons: [],
      showAlertModal: false,
      modalDesc: null,
      modalStatus: 0,
      tiersCount:null,
      isLoading:true

    };
  },

  methods: {
    ...mapActions("sManagePricing", ["SET_SELECTED_PRICING"]),
    ...mapActions("sSetupPricing", {
      SET_CLONE_TIER_REQUEST: "SET_CLONE_TIER_REQUEST",
      SET_CLONE_TIER_RESPONSE: "SET_CLONE_TIER_RESPONSE"
    }),

   onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.lsFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
            COMPONENT_NAME.SETUP_PRICING,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
 onPaginationChange(pItemsPerPage) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPaginationChange");
           this.setupPricingTableWatchList.itemsPerPage=pItemsPerPage;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SETUP_PRICING,
                  "error in onPaginationChange",
                  err.toString(),
                  "onPaginationChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

    onPageChange(pPageNum) {
        try {
          if(BaseConfiguration.isDebug) console.log("onPageChange");
    this.setupPricingTableWatchList.currentPageNum=pPageNum;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SETUP_PRICING,
                  "error in onPageChange",
                  err.toString(),
                  "onPageChange",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

    getFilteredAgentCount(pFilteredItems) {
        try {
          if(BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
         this.setupPricingTableWatchList.filteredlistCount=pFilteredItems.length;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.SETUP_PRICING,
                  "error in getFilteredAgentCount",
                  err.toString(),
                  "getFilteredAgentCount",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 
    getCloneModalButtons(pClonedPricingObj) {
      return [
        {
          name: this.$t("createPricing.ok"),
          func: this.navigateToManagePricing,
          param: pClonedPricingObj,
          color: "success"
        }
      ];
    },

    getDeleteModalButtons(pTierId) {
      //    this.tierId =pTierId
      return [
        {
          name: this.$t("createPricing.cancel"),
          func: this.toggleAlertModal,
          color: "danger"
        },

        {
          name: this.$t("createPricing.yes"),
          func: this.deletePricingTier,
          param: pTierId,
          color: "success"
        }
      ];
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
        this.showAlertModal = !this.showAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    setAlertModalDetails(pModalButtons, pDesc, pStatus) {
      try {
        if (BaseConfiguration.isDebug) console.log("setAlertModalDetails");
        this.lsModalButtons = pModalButtons;
        this.modalDesc = pDesc;
        this.modalStatus = pStatus;
        this.toggleAlertModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in setAlertModalDetails",
          err.toString(),
          "setAlertModalDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getPricingStatusURL() {
      return SERVICE_URL.PRICING_STATUS;
    },
    showAlert(val) {
      this.alertValue = val;
    },

    getPricingFileds() {
      if (BaseConfiguration.isDebug) console.log("getPricingFileds");
      return [
        {
          key: "name",
          label: this.$t("setupPricing.pricingTier"),
          _style: "width:40%",
          isLocked: true
        },
        {
          key: "isactive",
          label: this.$t("setupPricing.status"),
          _style: "width:20%",
          filter: true,
          sorter: false,
          isLocked: true
        },
        {
          key: "actions",
          label:this.$t("setupPricing.actions"),
          _style: "width:20%",
          filter: false,
          sorter: false,
          isLocked: true
        }
      ];
    },

    navigateToManagePricing(pSelectedPricingObj) {
      if (BaseConfiguration.isDebug) console.log("navigateToManagePricing");
      try {
        if (pSelectedPricingObj) {
          pSelectedPricingObj = JSON.parse(JSON.stringify(pSelectedPricingObj));
          this.SET_SELECTED_PRICING(pSelectedPricingObj);
        } else {
          this.SET_SELECTED_PRICING(null);
        }
        navigate(BaseConfiguration.isFormPricing? PATHNAME.MANAGE_SIMPLE_PRICING: PATHNAME.MANAGE_PRICING);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in navigateToManagePricing",
          err.toString(),
          "navigateToManagePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onStatusChange(pStatus) {
      if (BaseConfiguration.isDebug) console.log("onStatusChange");
      try {
        let pricingTiersList = JSON.parse(JSON.stringify(this.lsPricingTiers.tierList));
        if (
          pricingTiersList &&
          pricingTiersList.length &&
          pStatus &&
          pStatus.value != null
        ) {
          this.lsSetupPricingTableItems = pricingTiersList.filter(
            pricingTier => {
              return pricingTier.isactive == pStatus.value;
            }
          );
        } else if (pricingTiersList && pricingTiersList.length) {
          this.lsSetupPricingTableItems = this.lsPricingTiers.tierList;
        } else {
          this.lsSetupPricingTableItems = [];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in   onStatusChange",
          err.toString(),
          "  onStatusChange()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async deletePricingTier(pTierId) {
      if (BaseConfiguration.isDebug) console.log("deletePricingTier");

      try {
        this.toggleAlertModal();

        if (pTierId) {
          let deletePricingTierReq = apiDeletePricingTier.buildRequest(pTierId);

          if (deletePricingTierReq != null && deletePricingTierReq.tierId) {
            let deletePricingTierRes = await apiDeletePricingTier.getResponse(
              deletePricingTierReq
            );
            if (VALIDATE_SUCCESS_RES(deletePricingTierRes)) {
              let deleteStatus = deletePricingTierRes.data;
              if (deleteStatus) {
                //api>
                this.initTableData();

                this.showAlert(null);
              }
            } else {
              let error = getErrorMessage(deletePricingTierRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
                window.scrollTo(0, 0);
              }
            }
          } else {
            throw "invalid request";
          }
        } else {
          throw "not a valid tier id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in  deletePricingTier",
          err.toString(),
          "deletePricingTier()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async clonePricingTier(pTierId,pName) {
      if (BaseConfiguration.isDebug) console.log("clonePricingTier");

      try {
        if (pTierId) {
          let clonePricingTierReq = apiClonePricingTier.buildRequest(pTierId);

          if (clonePricingTierReq != null && clonePricingTierReq.tierid) {
            this.SET_CLONE_TIER_REQUEST(clonePricingTierReq);
            let clonePricingTierRes = await apiClonePricingTier.getResponse(
              clonePricingTierReq
            );
            if (VALIDATE_SUCCESS_RES(clonePricingTierRes)) {
              let clonedPricingObj = clonePricingTierRes.data.data;
              if (clonedPricingObj && clonedPricingObj.orgid) {
                delete clonedPricingObj.orgid;
                delete clonedPricingObj.org;
              }
              this.SET_CLONE_TIER_RESPONSE(clonedPricingObj);
              this.setAlertModalDetails(
                this.getCloneModalButtons(clonedPricingObj),
                this.$t("setupPricing.cloneStatus",{name:pName}),
                1 //model status;
              );
              //this.toggleAlertModal();

              this.showAlert(null);
            } else {
              let error = getErrorMessage(clonePricingTierRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                this.showAlert(getErrorAlertValue(error));
                window.scrollTo(0, 0);
              }
            }
          } else {
            throw "invalid request";
          }
        } else {
          throw "not a valid tier id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in  clonePricingTier",
          err.toString(),
          "clonePricingTier()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    

    async getAllPricingTiers() {
      if (BaseConfiguration.isDebug) console.log("getAllPricingTiers");
      let returnValue= {
        tierList : [],
        permission : {}
        };
      try {
        let allPricingTiersReq = apiAllPricingTiers.buildRequest(
          SECTOR_TYPE.ALL
        ); //constant

        if (allPricingTiersReq != null && allPricingTiersReq.filter) {
          let allPricingTiersRes = await apiAllPricingTiers.getResponse(
            allPricingTiersReq
          );
          if (VALIDATE_SUCCESS_RES(allPricingTiersRes)) {
           returnValue.tierList = allPricingTiersRes.data.data.tiersList;
           returnValue.permission = allPricingTiersRes.data.data.permission;
           returnValue.count=allPricingTiersRes.data.data.count;
            // this.permissionObj = allPricingTiersRes.data.permission;
            
            // returnValue = allPricingTiersRes.data.data;
            this.showAlert(null);
          } else {
            let error = getErrorMessage(allPricingTiersRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in  get All Pricing Tiers",
          err.toString(),
          "getAllPricingTiers()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },
     getPropToSortTiers(pTier) {
                try {
                  if(BaseConfiguration.isDebug) console.log("getPropToSortTiers");
                if(pTier.name){
                  
                    
                    return pTier.name.toLowerCase();
                }
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.SETUP_PRICING,
                          "error in getPropToSortTiers",
                          err.toString(),
                          "getPropToSortTiers",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                }, 

    async initTableData() {
      try {
        let listPricingTiers = await this.getAllPricingTiers();
        if(listPricingTiers&&listPricingTiers.count){
        this.tiersCount=listPricingTiers.count;

        }
        this.lsPricingTiers = listPricingTiers;
        
          listPricingTiers =OrderByList(listPricingTiers.tierList,this.getPropToSortTiers,ORDER.ASC);

        if (listPricingTiers && listPricingTiers.length) {
          // this.lsPricingTiers = listPricingTiers;
          this.lsSetupPricingTableItems = listPricingTiers;
          this.SET_CLONE_TIER_RESPONSE(null);
        } else {
          this.lsSetupPricingTableItems = [];
        }

        this.lsFields = this.getPricingFileds();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SETUP_PRICING,
          "error in  initTableData",
          err.toString(),
          " initTableData()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
  async created() {
    if (BaseConfiguration.isDebug) console.log("created");
    try {
      await this.initTableData();
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.SETUP_PRICING,
        "error in  Created",
        err.toString(),
        " Created()",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
    beforeCreate() {    
   addClassToBody(COMPONENT_NAME.SETUP_PRICING);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>
<style>
.dropdown {
  margin-bottom: 10px;
}
.header {
  padding-top: 10px;
}
</style>
